import { CompanyService } from '../services'
import Vue from 'vue'

export const state = {
	items: [],
	meta: {
		total: 0,
		current_page: 1,
		per_page: 15,
		last_page: 1,
		from: 0,
		to: 0
	},
	singleItems: [],
	companyLeads: [],
	companyLeadsTotal: [],
	industries: []
}

export const actions = {
	getAll ({ commit, dispatch }, params) {
		return CompanyService.getAll(params)
			.then(response => {
				commit('setCompanies', response)
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
			})
	},
	getSingle ({ commit, dispatch }, data) {
		return CompanyService.getCompanyById(data)
			.then(response => {
				commit('updateSingleCompany', response.data)
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
			})
	},
	getCompanyLeads ({ commit, dispatch }, data) {
		return CompanyService.getCompanyLeads(data.companyId, data.page)
			.then(results => {
				commit('updateCompanyLeads', {
					leads: results.data,
					total: results.meta.total,
					companyId: data.companyId
				})
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
			})
	},
	getIndustries ({ commit, dispatch }) {
		return CompanyService.getIndustries()
			.then(results => {
				commit('updateIndustries', results.data)
				return results.data
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
				throw error
			})
	},
	getPrimaryMarkets ({ commit, dispatch }) {
		return CompanyService.getPrimaryMarkets()
			.then(results => {
				return results.data
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
				throw error
			})
	},
	searchCompanies ({ commit, dispatch }, params) {
		return CompanyService.searchCompanies(params)
			.then(results => {
				commit('setCompanies', results.data)
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
			})
	},
	createCompany ({ commit, dispatch }, data) {
		return CompanyService.createCompany(data)
			.then(company => {
				company = company.data
				commit('addSingleCompany', company)
				return company
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
			})
	},
	updateCompany ({ commit, dispatch }, data) {
		return CompanyService.updateCompany(data.id, data)
			.then(company => {
				company = company.data
				commit('updateSingleCompany', company)
				return company
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
			})
	},
	deleteCompany ({ commit, dispatch }, companyId) {
		return CompanyService.deleteCompany(companyId)
			.then(() => {
				commit('removeSingleCompany', companyId)
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
			})
	},
	getCompanyRecentLeads ({ commit, dispatch }, data) {
		return CompanyService.getCompanyRecentLeads(data.companyId, data.days)
			.then(response => {
				return response.data
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
				throw error
			})
	},
	getCompanyActiveEvents ({ commit, dispatch }, companyId) {
		return CompanyService.getCompanyActiveEvents(companyId)
			.then(response => {
				return response.data
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
				throw error
			})
	},
	associateLeads ({ commit, dispatch }, data) {
		return CompanyService.associateLeads(data.company_id, data.lead_ids)
			.then(response => {
				return response.data
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
				throw error
			})
	},
	removeLeadAssociation ({ commit, dispatch }, data) {
		return CompanyService.removeLeadAssociation(data.company_id, data.lead_id)
			.then(response => {
				return response.data
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
				throw error
			})
	},
	mergeCompanies ({ commit, dispatch }, data) {
		return CompanyService.mergeCompanies(data.target_company_id, data.source_company_id)
			.then(response => {
				// Remove the merged (source) company from the store
				commit('removeSingleCompany', data.source_company_id)
				return response.data
			})
			.catch(error => {
				dispatch('alert/error', error, { root: true })
				throw error
			})
	}
}

export const mutations = {
	setCompanies (state, response) {
		state.items = response.data
		state.meta = response.meta
	},
	updateSingleCompany (state, company) {
		state.singleItems = state.singleItems.filter(function (item) {
			return parseInt(item.id) !== parseInt(company.id)
		})
		state.singleItems.push(company)
	},
	addSingleCompany (state, company) {
		state.items.push(company)
		state.singleItems.push(company)
	},
	removeSingleCompany (state, companyId) {
		state.items = state.items.filter(function (item) {
			return parseInt(item.id) !== parseInt(companyId)
		})
		state.singleItems = state.singleItems.filter(function (item) {
			return parseInt(item.id) !== parseInt(companyId)
		})
	},
	updateCompanyLeads (state, data) {
		Vue.set(state.companyLeads, data.companyId, data.leads)
		Vue.set(state.companyLeadsTotal, data.companyId, data.total)
	},
	updateIndustries (state, data) {
		state.industries = data
	}
}

export const getters = {
	getSingleCompanyById: (state) => (id) => {
		let company = state.singleItems.find(company => parseInt(company.id) === parseInt(id))
		return company || {}
	},
	getCompanyLeadsByCompanyId: (state) => (companyId) => {
		return state.companyLeads[companyId] || []
	},
	getCompanyLeadsTotalByCompanyId: (state) => (companyId) => {
		return state.companyLeadsTotal[companyId] || 0
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}